import { SectionLabel, Reveal, scrollToId } from "../landing/shared";
import { APPLY_CTA_LABEL } from "./config";

const ITEMS = [
  "A one-on-one Better Deal Review™ with Josh — after your application and required authorizations are complete",
  "A whole-deal walkthrough of your situation instead of a single quote — discussed live on the call",
  "A plain-language explanation of the application path and what each authorization is for",
  "A verbal assumptions & next-step recap at the end of the conversation",
];

export default function Manifest() {
  return (
    <section className="py-24 lg:py-36 px-6 lg:px-10 bg-white/[0.015]" data-testid="manifest-section">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <SectionLabel n="002" text="WHAT'S WAITING" />
          <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight mb-12">
            HERE'S WHAT HAPPENS WHEN YOU TAKE THE NEXT STEP
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border border-white/12 bg-[#00224F]/50 p-8 lg:p-10">
            <ul className="space-y-5">
              {ITEMS.map((item, i) => (
                <Reveal key={i} delay={0.15 + i * 0.12}>
                  <li className="flex gap-4 text-white/75 text-[15px] leading-relaxed" data-testid={`manifest-item-${i + 1}`}>
                    <span className="text-[#0162CA] font-bold shrink-0">✓</span>
                    {item}
                  </li>
                </Reveal>
              ))}
            </ul>
            <p className="mt-8 text-[#0162CA] font-semibold text-[15px]">
              There's no fee to you for the review. What it costs is honest information and your time.
            </p>
          </div>
          <p className="mt-4 text-[11px] text-white/35">
            Everything above is delivered live on the call. We do not send a PDF, guide, checklist, or workbook.
          </p>
          <p className="mt-2 text-[11px] text-white/35">
            A limited number of Better Deal Reviews™ are available after each live class because Josh personally
            reviews the completed information.
          </p>
          <div className="mt-8">
            <button type="button" data-cursor="cta" data-testid="manifest-cta" onClick={() => scrollToId("apply")} className="cta-btn">
              {APPLY_CTA_LABEL}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
